import { ArrowIcon } from "@cmsgov/ds-medicare-gov";
import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { Link } from "react-router-dom";
import { SearchResultPlan, UserLanguage } from "../../../../@types";
import { AnalyticsActionType } from "../../../../app/contexts/Analytics/types";
import { AppContext } from "../../../../app/store";
import {
  getPlanName,
  makePlanDetailsUrl,
  makePlanDisplayId,
  useTranslate,
} from "../../../../helpers";
import BasePlanCard from "./BasePlanCard";

export interface CurrentCoverageCardProps {
  language: UserLanguage;
  isOutsideOpenEnrollment?: boolean;
  plan?: SearchResultPlan;
}

export const currentCoverageCardTestId = "current-coverage-card";
export const currentCoverageCardNoPlanTestId = "current-coverage-card-no-plan";

const CurrentCoverageCard: FunctionComponent<CurrentCoverageCardProps> = ({
  plan,
  language = UserLanguage.ENGLISH,
  isOutsideOpenEnrollment,
}) => {
  const { state, dispatch } = useContext(AppContext);
  const url = window.location.href.split("/summary?")[0];
  const { year } = state;
  const t = useTranslate();

  if (plan) {
    const linkText = t("summary_page.links.get_plan_details");
    const linkUrl = makePlanDetailsUrl({
      plan,
      language,
      yearValue: "contract_year",
    });
    return (
      <BasePlanCard
        dataTestId={currentCoverageCardTestId}
        header={
          isOutsideOpenEnrollment ? (
            t("summary_page.plan_cards.current_coverage.header.OOE")
          ) : (
            <FormattedMessage
              id="summary_page.plan_cards.current_coverage.header.OE"
              values={{ year: plan.contract_year }}
            />
          )
        }
        planHeader={
          <p className="mct-c-summary-page-plan-card__plan-header">
            {getPlanName(plan, language)}
          </p>
        }
        subHeader={t(
          "summary_page.plan_cards.current_coverage.subheader.right_now"
        )}
        planId={makePlanDisplayId(plan)}
        footer={
          <>
            <Link
              className="mct-c-summary-page-plan-card__link"
              to={linkUrl}
              onClick={() =>
                dispatch({
                  type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
                  settings: {
                    linkText,
                    linkUrl: `${url}${linkUrl}`,
                  },
                })
              }
            >
              {linkText}
            </Link>
            <ArrowIcon className="ds-u-margin-left--05" direction="right" />
          </>
        }
      />
    );
  } else {
    return (
      <BasePlanCard
        dataTestId={currentCoverageCardNoPlanTestId}
        header={
          isOutsideOpenEnrollment ? (
            t("summary_page.plan_cards.current_coverage.header.OOE")
          ) : (
            <FormattedMessage
              id="summary_page.plan_cards.current_coverage.header.OE"
              values={{ year }}
            />
          )
        }
        subHeader={t(
          "summary_page.plan_cards.current_coverage.subheader.generic"
        )}
      />
    );
  }
};

export default CurrentCoverageCard;
